import Component from "../../../../js/assets/component.js"
import SlideShowItem from "./slideshow_item.js"

class LargeSlideshow extends Component {
  constructor(el){
    super(el)
  }

  data(){
    return {
      // "loaded": false,
      "loading": false,
      "slideInterval": 7000,
      "slideMaxLength": null,
      "activeIndex": null
    }
  }

  changed(){
    return {
      "loading": (val)=>{
        if(val===true){
          this.$loading.removeClass("-inActive")
          this.$loading.addClass("-active")
        }else{
          this.$loading.removeClass("-active")
          this.$loading.addClass("-inActive")
        }
      },

      "activeIndex": (index, prev) => {
        //画像を差し替え
        this.swapImage(index)
        //次の画像を先読み
        this.preLoadNextImage()
      }
    }
  }

  activate(){
    this.nextImage()
    this.$el.removeClass("-inActive")
    this.$el.addClass("-active")
  }

  inActivate(){
    this.clearSlideTimer()
    this.$el.removeClass("-active")
    this.$el.addClass("-inActive")
  }

  /*
  * 画像の表示を差し替える
  */
  swapImage(index){
    for(let i=0; i<this.slideshowItem.length; i++){
      if(i === index){
        this.slideshowItem[i].activate()
        this.$caption[i].addClass("-active")
      }else{
        this.slideshowItem[i].inActivate()
        this.$caption[i].removeClass("-active")
      }
    }
  }

  /*
  * 次に表示する画像を先読み
  */
  async preLoadNextImage(){

    var nextIndex
    if( this.$data.activeIndex === null ){
      nextIndex = 0
    }else{
      nextIndex = this.$data.activeIndex + 1
      if(nextIndex >= this.$data.slideMaxLength){
        nextIndex = 0
      }
    }
    if(this.slideshowItem[nextIndex].$data.loaded === false){
      this.slideshowItem[nextIndex].load()
    }

  }

  async nextImage(){
    this.clearSlideTimer()

    var nextIndex
    if( this.$data.activeIndex === null ){
      nextIndex = 0
    }else{
      nextIndex = this.$data.activeIndex + 1
      if(nextIndex >= this.$data.slideMaxLength){
        nextIndex = 0
      }
    }

    //次の画像の読み込みが完了するまで待機
    if(this.slideshowItem[nextIndex].$data.loading === false){
      this.$data.loading = true
      await this.slideshowItem[nextIndex].load()
    }else if(this.slideshowItem[nextIndex].$data.loaded === false){
      this.$data.loading = true
      await this.slideshowItem[nextIndex].waitLoaded()
    }
    this.$data.loading = false

    //読み込み完了したらactiveIndexを更新
    this.$data.activeIndex = nextIndex

    this.startSlideTimer()
  }

  startSlideTimer() {
    this.clearSlideTimer()
    this.slideTimer = setTimeout(() => {
      this.nextImage()
    }, this.$data.slideInterval)
  }

  clearSlideTimer(){
    if(this.slideTimer===undefined){
      return
    }
    clearTimeout(this.slideTimer)
  }

  mounted() {
    var self = this

    //inActivate
    this.inActivate()

    //loading
    this.$loading = this.$el.find(".loading")
    this.$loading.addClass("-active")

    //image
    this.slideshowItem = []
    this.$el.find("li.largeSlideShow_item").each(function(i){
      self.slideshowItem[i] = new SlideShowItem($(this))
      self.slideshowItem[i].registerImage($(this).attr("data-image"))
    })

    //caption
    this.$caption = []
    this.$el.find("li.largeSlideShow_caption").each(function(i){
      self.$caption.push($(this))
    })
    this.$data.slideMaxLength = this.slideshowItem.length
  }
}


export default LargeSlideshow
